import React, { useState, useEffect, lazy } from 'react';
import PropTypes from 'prop-types';
import RenderComponent from './RenderComponent';
import { getLastQuaters } from 'globalutils/fmUtils';
import { prepareVehicleLists } from './helper';
import { UI_DATE_FORMAT, DATE_FORMAT_REGEX, DATE_FORMAT_REPLACEMENT } from 'globalconfig/constants/static';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));

const ViewForm = ({
  hasApiStatus,
  callback,
  vehicles,
  fetchIftaMileage,
  iftaApiId,
  handleExportIfta,
  tableData,
  history,
  fetchReport,
  commonProps,
  isOldView,
  i18n,
}) => {
  const { activeVehicles, deActivatedVehicles } = prepareVehicleLists(vehicles, i18n);

  const lastQuater = getLastQuaters(true);
  const [initialValues] = useState({
    id: { label: i18n.t('users.All'), value: '' },
    vehicleType: 'active',
    fromOdometer: 'true',
    dateRange: [lastQuater[0].format(UI_DATE_FORMAT), lastQuater[1].format(UI_DATE_FORMAT)],
    dateTimeFrom: lastQuater[0].format(UI_DATE_FORMAT),
    dateTimeTo: lastQuater[1].format(UI_DATE_FORMAT),
    hideStates: true,
  });

  const handleOnSubmit = (fields) => {
    fetchIftaMileage({
      apiId: iftaApiId,
      data: {
        id: fields.vehicleType === 'inactive' && fields.id.label === 'All' ? '0' : fields.id.value,
        fromOdometer: fields.fromOdometer,
        dateTimeFrom: fields.dateTimeFrom?.replace(DATE_FORMAT_REGEX, DATE_FORMAT_REPLACEMENT),
        dateTimeTo: fields.dateTimeTo?.replace(DATE_FORMAT_REGEX, DATE_FORMAT_REPLACEMENT),
      },
    });
    tableData(fields);
  };

  return (
    <Form
      type="server"
      direction="row"
      initialValues={initialValues}
      RenderComponent={RenderComponent}
      handleOnSubmit={handleOnSubmit}
      handleOnCancel={() => { }}
      customProps={{
        callback,
        hasApiStatus,
        activeVehicles,
        deActivatedVehicles,
        handleExportIfta,
        fetchReport,
        commonProps,
        isOldView,
        history,
      }}
    />
  );
};

ViewForm.propTypes = {
  hasApiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  vehicles: PropTypes.object.isRequired,
  fetchIftaMileage: PropTypes.func.isRequired,
  iftaApiId: PropTypes.string.isRequired,
  handleExportIfta: PropTypes.func.isRequired,
  tableData: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  fetchReport: PropTypes.func.isRequired,
  commonProps: PropTypes.object.isRequired,
  isOldView: PropTypes.bool.isRequired,
  i18n: PropTypes.object.isRequired,
};

export default ViewForm;